import axiosInstance from '../../../axios-config';

const postCreateAccountUrl = '/api/patients/signup/postAccountInformation?language={language}';
const getPasswordRulesUrl = '/api/patients/signup/passwordRules';

export const postCreateAccount = (accountInformation, language) =>
  axiosInstance.post(
    postCreateAccountUrl.replace('{language}', language),
    accountInformation);

export const getPasswordRules = () => axiosInstance.get(getPasswordRulesUrl);
